import React from 'react';
import { RequestInformationPage } from './RequestInformationPage';

// /request-information/new-start-assistance — the Request Information flow
// with landing copy written for people with a criminal record who want to go
// back to school online. Same streamlined question set and lead handling as
// the v1 template; only the landing messaging differs.
export function RequestInformationNewStartAssistancePage() {
  return <RequestInformationPage variant="new-start-assistance" content={{
    metaTitle: 'Online Colleges for People With a Record | FindOnlineDegrees',
    metaDescription: 'Find online degree programs that welcome students with a criminal record. Compare schools, explore financial aid, and start your comeback.',
    badge: 'Second-Chance Friendly Schools',
    headline: 'Your Record Doesn’t Have to',
    headlineAccent: 'Decide Your Future',
    subhead: 'Plenty of accredited online colleges enroll students with a criminal record. Answer a few questions and we’ll match you with programs that fit your goals — no background check to get started, no judgment.',
    stats: [{
      value: '100%',
      label: 'Online options'
    }, {
      value: 'Aid',
      label: 'May be available'
    }, {
      value: 'Private',
      label: 'No record required'
    }],
    features: ['Schools that consider applicants with a record', 'Study from home — no campus commute required', 'Financial aid guidance, including Pell Grant eligibility', 'Career-focused programs in growing fields', 'No application fees to explore your options'],
    formHeading: 'Start Your Comeback',
    formSubhead: 'Tell us what you want to study',
    supportNote: {
      heading: 'Going back to school with a record',
      body: 'A conviction closes fewer doors in higher education than most people expect. Here’s what actually matters as you compare online programs.',
      points: [{
        title: 'Applying is usually record-blind',
        body: 'Most online colleges don’t ask about criminal history on the application and don’t run a background check to admit you.'
      }, {
        title: 'Financial aid is often available',
        body: 'Federal Pell Grants are available to many students with past convictions, including people currently incarcerated under Second Chance Pell.'
      }, {
        title: 'Choose the field with open eyes',
        body: 'Business, IT, accounting, psychology, and communications rarely involve licensing hurdles. Nursing, education, and criminal justice often do.'
      }],
      footnote: 'Some licensed careers run background checks before clinical placement, internships, or state licensure. Ask each school how your specific record affects that specific program before you enroll — a good advisor will answer directly.'
    }
  }} data-id="element-2423" data-mp="2xzgubn2v8fgs" />;
}